// src/pages/BlogCategory.js
import React from 'react';
import { 
  Box, 
  Container, 
  Heading, 
  Grid,
  useToast
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import BlogPostCard from '../components/BlogPostCard';
import { blogPosts } from '../blogData';
import InnerPageHero from '../components/sections/InnerPageHero';
import { FaHome } from 'react-icons/fa';

function BlogCategory() {
  const { category } = useParams();
  const toast = useToast();
  const decodedCategory = decodeURIComponent(category);
  const filteredPosts = blogPosts.filter(post => 
    post.category.toLowerCase() === decodedCategory.toLowerCase()
  );

  if (filteredPosts.length === 0) {
    toast({
      title: 'No posts found',
      description: `No posts available in ${decodedCategory} category`,
      status: 'info',
      duration: 3000,
      isClosable: true,
    });
  }

  return (
    <div className="app-container">
      <InnerPageHero 
        title={`Category: ${decodedCategory}`}
        breadcrumbs={[
          { label: 'Home', href: '/', icon: FaHome },
          { label: 'Blog', href: '/blog' },
          { label: decodedCategory, isCurrentPage: true }
        ]}
      />
      
      <Box as="section" py={{ base: 8, md: 12 }} bg="gray.50">
        <Container maxW="container.xl">
          <Heading as="h2" fontSize="2xl" mb={6}>
            Posts in {decodedCategory}
          </Heading>
          <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={6}>
            {filteredPosts.map(post => (
              <BlogPostCard key={post.id} post={post} />
            ))}
          </Grid>
        </Container>
      </Box>
    </div>
  );
}

export default BlogCategory;